import { useRef } from 'react'

// Generic type to create tuple from arguments
type StableResultTuple<T extends ReadonlyArray<unknown>> = T

const useStableResult = <T extends ReadonlyArray<unknown>>(
  ...args: T
): StableResultTuple<T> => {
  const resultRef = useRef<T>(args)

  // Update the ref with new values while maintaining reference stability
  args.forEach((value, index) => {
    // Cast to unknown first to handle readonly constraint
    ;(resultRef.current as unknown as Array<unknown>)[index] = value
  })

  return resultRef.current
}

export default useStableResult
